/* ========================================================================
   On document ready do stuff
 ========================================================================== */

util.onDocumentReady(function () {
  // Enable SVG in IE11
  // svg4everybody();

  // Enable transitions
  document.documentElement.classList.remove('preloadTransitions');

  app.touch.init();
  app.general.initAppHeight();
  app.navigation.initMenu();
  app.navigation.initSearchBox();
  app.linkBlocks.init();
  app.newsOverview.init();
  app.iconBlocks.init();
  app.faqBlock.init();
  app.general.initEmailLinks();
  app.general.initVideoLinks();
  app.general.initMatchHeights();
  app.general.initLax();
  app.cookiePopup.init();
  app.dataLayer.init();
});
